import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../imagem/logo_navbar.webp";

function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (target) => {
    if (target.startsWith("/")) {
      navigate(target);
      window.scrollTo({ top: 0, behavior: "instant" });
    } else {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const el = document.getElementById(target);
          if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
        }, 500);
      } else {
        const el = document.getElementById(target);
        if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
      }
    }
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`navbar-henrimack ${scrolled ? "navbar-scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand onClick={() => handleNavClick("/")} className="brand-elite me-lg-auto">
          <img src={logo} alt="Henrimack" className="navbar-logo-img" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" aria-label="Abrir menu de navegação" className="navbar-toggle-elite" />

        <Navbar.Collapse id="navbar-nav" className="flex-lg-grow-0">
          <Nav className="nav-links-elite gap-lg-4 mx-lg-5">
            {[
              { name: "SGE PRO", id: "/sge-pro" },
              { name: "SOBRE", id: "about" },
              { name: "SERVIÇOS", id: "services" },
              { name: "PORTFÓLIO", id: "portfolio" },
              { name: "CONTATO", id: "contact" },
            ].map((item, idx) => (
              <Nav.Link
                key={idx}
                onClick={() => handleNavClick(item.id)}
                className="nav-link-white"
              >
                {item.name}
              </Nav.Link>
            ))}
          </Nav>

          <div className="nav-actions d-none d-lg-flex">
            <Button
              onClick={() => handleNavClick("contact")}
              className="btn-talk-elite px-4 py-2"
            >
              Falar com Consultor
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .navbar-logo-img {
          height: 52px;
          object-fit: contain;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .nav-link-white {
          font-size: 0.85rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          white-space: nowrap;
        }

        .btn-talk-elite {
          background: transparent;
          border: 1px solid var(--elite-gold);
          color: var(--elite-gold);
          font-weight: 700;
          font-size: 0.8rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          border-radius: 50px;
          transition: all 0.3s ease;
        }

        .btn-talk-elite:hover {
          background: var(--elite-gold);
          color: #000;
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(228, 168, 122, 0.2);
        }

        .navbar-toggle-elite {
          border: none;
          filter: invert(1);
        }

        @media (max-width: 991px) {
           .navbar-collapse {
              background: rgba(15, 15, 15, 0.98);
              margin-top: 1rem;
              padding: 2rem;
              border-radius: 30px;
              border: 1px solid rgba(255,255,255,0.1);
              backdrop-filter: blur(20px);
           }
           .nav-link-white { text-align: center; padding: 1rem !important; }
        }
      `}</style>
    </Navbar>
  );
}

export default Navigation;
